import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toastConfig } from "config";
import { useCallback, useContext } from "react"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { app } from "router/routes";
import { getCurrentSemesterAndYear } from "utils/general";
import { CreatePracticesContext } from "../CreatePracticesContext";
import { allocationBatteryFetch } from "store/middlewares/assessment.crud";

const useCreatePractices = () => {
    const navigate = useNavigate()

    const { selectedAssessmentDefs, selectedTestTaker } = useContext(CreatePracticesContext)

    const { mutateAsync: createAssessments, isPending } = useMutation({
        mutationFn: allocationBatteryFetch,
        onSuccess: () => {
            // ריפרש לשאילתות רלוונטיות כדי לעדכן את רשימת המבדקים במערכת
            // queryClient.invalidateQueries([qc.assessments]);
            toast.success('ההקצאה בוצעה בהצלחה', toastConfig);
            // ניווט רק אחרי הצלחה
            navigate(app.practiceAssessments);
        },
        onError: (error) => {
            const { data } = error?.response || {}
            const msg =
                data?.detail || data?.error ||
                'אופס, משהו השתבש בהקצאה';
            toast.error(msg, toastConfig);
        }
    })

    const createPractices = useCallback(() => {
        const { semester, school_year } = getCurrentSemesterAndYear()

        const payload = {
            test_takers: [{
                test_taker_id: selectedTestTaker.id,
                learning_unit_id: selectedTestTaker.learning_unit.id
            }],
            assessment_defs: selectedAssessmentDefs.map(ass => ({
                id: ass.id
                // בעבר העברנו גם layout_type בנתיים בטלתי אותו 
            })),

            school_year: school_year.id,
            semester_of_execution: semester.id,
            is_practice: true
        }

        createAssessments(payload)
    }, [selectedTestTaker, selectedAssessmentDefs])

    return { isPending, action: createPractices }
}

export default useCreatePractices